<!-- <button mat-icon-button (click)="toggleRefresh()">test</button> -->
<div #mapContainer class="offline-map-container" [style.width]="width" [style.height]="height"></div>
<div class="maptiler-options" *ngIf="showMapTilerOptions" (click)="$event.stopPropagation()">
  <div class="maptiler-options__panel" *ngIf="mapTilerOptionsOpen" role="group" [attr.aria-label]="'Map options' | translate">
    <button type="button" class="maptiler-options__section" (click)="mapTilerStyleSectionOpen = !mapTilerStyleSectionOpen"
      [attr.aria-expanded]="mapTilerStyleSectionOpen">
      <span class="maptiler-options__section-title">{{ 'Map style' | translate }}</span>
      <span class="maptiler-options__section-current">{{ mapTilerStyleLabelKey | translate }}</span>
      <mat-icon class="material-icons" aria-hidden="true">{{ mapTilerStyleSectionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="maptiler-options__section-body" *ngIf="mapTilerStyleSectionOpen">
      <label class="maptiler-options__item" *ngFor="let style of mapTilerStyles"
        [class.maptiler-options__item--selected]="mapTilerStyleId === style.id">
        <input type="radio" name="maptiler-style" [value]="style.id" [checked]="mapTilerStyleId === style.id"
          (change)="selectMapTilerStyle(style.id)">
        <span>{{ style.labelKey | translate }}</span>
      </label>
    </div>
    <button type="button" class="maptiler-options__section" (click)="mapTilerLayersSectionOpen = !mapTilerLayersSectionOpen"
      [attr.aria-expanded]="mapTilerLayersSectionOpen">
      <span class="maptiler-options__section-title">{{ 'Map layers' | translate }}</span>
      <mat-icon class="material-icons" aria-hidden="true">{{ mapTilerLayersSectionOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    <div class="maptiler-options__section-body maptiler-options__section-body--layers" *ngIf="mapTilerLayersSectionOpen">
      <label class="maptiler-options__item" [class.maptiler-options__item--selected]="mapTiler3dEnabled">
        <input type="checkbox" [checked]="mapTiler3dEnabled" (change)="toggleMapTilerOption('3d')">
        <span>{{ 'Enable 3D layer' | translate }}</span>
      </label>
      <label class="maptiler-options__item" [class.maptiler-options__item--selected]="mapTilerElevationEnabled">
        <input type="checkbox" [checked]="mapTilerElevationEnabled" (change)="toggleMapTilerOption('elevation')">
        <span>{{ 'Enable elevation' | translate }}</span>
      </label>
      <label class="maptiler-options__item" [class.maptiler-options__item--selected]="mapTilerHillshadeEnabled">
        <input type="checkbox" [checked]="mapTilerHillshadeEnabled" (change)="toggleMapTilerOption('hillshade')">
        <span>{{ 'Enable hillshade' | translate }}</span>
      </label>
    </div>
  </div>
  <button type="button" class="maptiler-options__toggle" [class.maptiler-options__toggle--open]="mapTilerOptionsOpen"
    (click)="mapTilerOptionsOpen = !mapTilerOptionsOpen" [attr.aria-expanded]="mapTilerOptionsOpen"
    [attr.aria-label]="'Map options' | translate">
    <mat-icon class="material-icons" aria-hidden="true">layers</mat-icon>
  </button>
</div>
<div class="offline-map-context-menu" *ngIf="contextMenuVisible" [style.left.px]="contextMenuLeft"
  [style.top.px]="contextMenuTop" role="menu" (click)="$event.stopPropagation()">
  <div class="offline-map-context-menu__header">
    <div *ngIf="contextMenuAddressLoading"
      class="offline-map-context-menu__address offline-map-context-menu__address--loading">
      {{ 'Loading address' | translate }}...
    </div>
    <div *ngIf="!contextMenuAddressLoading && contextMenuAddress" class="offline-map-context-menu__address">
      {{ contextMenuAddress }}
    </div>
  </div>

  <ng-container *ngIf="forBuildingFlow && contextMenuSavedPolygonBuildingId">

    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      (click)="emitViewFloorPlansFromPolygonContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">layers</mat-icon>
      {{ 'Enter Site' | translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      (click)="emitLocateRoomFromPolygonContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">meeting_room</mat-icon>
      {{ 'Locate a Room' | translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      (click)="emitEditSavedPolygonFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">edit</mat-icon>
      {{ 'Edit Site' | translate }}
    </button>
    <button type="button"
      class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon offline-map-context-menu__item--threat"
      (click)="emitDeleteSavedPolygonFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">delete</mat-icon>
      {{ 'Delete Site' | translate }}
    </button>
  </ng-container>

  <!-- <ng-container *ngIf="forBuildingFlow && editMode && buildingFootprintDraftActive">
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      [disabled]="!buildingFootprintCanSave" (click)="saveBuildingFootprintDraft()">
      <mat-icon class="material-icons" aria-hidden="true">save</mat-icon>
      {{ 'Save site footprint' | translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      (click)="cancelBuildingFootprintDraft()">
      <mat-icon class="material-icons" aria-hidden="true">close</mat-icon>
      {{ 'Cancel footprint drawing' | translate }}
    </button>
    <mat-divider class="offline-map-context-menu__divider"></mat-divider>
  </ng-container> -->

  <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    *ngIf="forBuildingFlow && !buildingFootprintDraftActive && !contextMenuSavedPolygonBuildingId"
    [disabled]="contextMenuAddressLoading" (click)="emitAddBuildingFromContextMenu()">
    <mat-icon class="material-icons" aria-hidden="true">add_location_alt</mat-icon>
    {{ 'Add Site' | translate }}
  </button>

  <ng-container *ngIf="isCasePage">
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      *ngIf="contextMenuCoverageCameras.length" (click)="findCameraCoverageFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">video_camera_back</mat-icon>
      {{ 'Camera Coverage' |
      translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      *ngIf="contextMenuCaseBuildingFootprintId" (click)="viewFloorPlansFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">layers</mat-icon>
      {{ 'Enter Site' |
      translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      *ngIf="contextMenuCaseBuildingFootprintId" (click)="locateRoomFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">meeting_room</mat-icon>
      {{ 'Locate a Room' | translate }}
    </button>
    <mat-divider class="offline-map-context-menu__divider"></mat-divider>
    <ng-container *ngIf="showContextMenuNoteActions">
      <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
        [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="addNote('note')">
        <mat-icon class="material-icons" aria-hidden="true">note_add</mat-icon>{{ 'Add Note' | translate }}
      </button>
      <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
        [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="addNote('personOfInterest')">
        <mat-icon class="material-icons" aria-hidden="true">person_add</mat-icon>{{ 'Add Person of Interest' | translate
        }}
      </button>
      <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
        [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="addNote('carOfInterest')">
        <mat-icon class="material-icons" aria-hidden="true">directions_car</mat-icon>{{ 'Add Car of Interest' |
        translate
        }}
      </button>
      <mat-divider class="offline-map-context-menu__divider"></mat-divider>
      <button type="button"
        class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon offline-map-context-menu__item--threat"
        [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="addNote('threat')">
        <mat-icon class="material-icons" aria-hidden="true">warning</mat-icon>
        {{ 'Add Incident' | translate }}
      </button>
    </ng-container>
  </ng-container>
  <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    [disabled]="contextMenuDispatchDisabled" (click)="openDispatchFromContextMenu()" *ngIf="isShowDispatch">
    <mat-icon class="material-icons" aria-hidden="true">shield</mat-icon>
    {{ 'Dispatch' | translate }}
  </button>
  <mat-divider class="offline-map-context-menu__divider"></mat-divider>

  <ng-container *ngIf="isCasePage">
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="openAreaOfInterestFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">signal_wifi_4_bar</mat-icon>{{ 'Add Base Station Location' |
      translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="openMapAnnotationFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true">draw</mat-icon>{{ 'Add Map Annotation' | translate }}
    </button>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
      [disabled]="contextMenuAddressLoading || !contextMenuAddress" (click)="openGoToLocationFromContextMenu()">
      <mat-icon class="material-icons" aria-hidden="true"><img src="assets/images/icon/go_to_location.svg"
          style="width:0.9rem" /></mat-icon>{{
      'Go to Location' | translate }}
    </button>
    <mat-divider class="offline-map-context-menu__divider"></mat-divider>
  </ng-container>
  <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    (click)="onMapContextMenuOption('centerHere')">
    <mat-icon class="material-icons" aria-hidden="true"><img src="assets/images/icon/center.svg"
        style="width:0.9rem" /></mat-icon>{{ 'Center map here' | translate }}
  </button>
  <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    (click)="onMapContextMenuOption('copyCoordinates')">
    <mat-icon class="material-icons" aria-hidden="true">content_copy</mat-icon>{{ 'Copy coordinates' | translate }}
  </button>
  <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    (click)="resetMapViewFromContextMenu()">
    <mat-icon class="material-icons" aria-hidden="true">restart_alt</mat-icon>{{ 'Reset map view' | translate }}
  </button>
  <ng-container *ngIf="isSuperAdmin && isShowAddPatrolCamera && isCasePage">
    <mat-divider class="offline-map-context-menu__divider"></mat-divider>
    <button type="button" class="offline-map-context-menu__item offline-map-context-menu__item--with-leading-icon"
    (click)="openAddPatrolCameraFromContextMenu()" >
    <mat-icon class="material-icons" aria-hidden="true">video_camera_back</mat-icon>
    {{ 'Position Patrol Camera' | translate }}
    </button>
  </ng-container>
</div>
